module.exports = __webpack_public_path__ + "img/album15_08.674208e7.jpg";